export const initTaskData = [
  {
    groupId: "col_1",
    content: "success",
    isDragDisabled: false,
    customData: { valueNow: 40 },
  },
  {
    groupId: "col_1",
    content: "info",
    isDragDisabled: false,
    customData: { valueNow: 50 },
  },
  {
    groupId: "col_1",
    content: "warning",
    isDragDisabled: false,
    customData: { valueNow: 60 },
  },
  {
    groupId: "col_1",
    content: "danger",
    isDragDisabled: false,
    customData: { valueNow: 70 },
  },
  {
    groupId: "col_1",
    content: "danger",
    isDragDisabled: false,
    customData: { valueNow: 70 },
  },
  {
    groupId: "col_2",
    content: "danger",
    isDragDisabled: false,
    customData: { valueNow: 80 },
  },
  {
    groupId: "col_3",
    content: "danger",
    isDragDisabled: false,
    customData: { valueNow: 13 },
  },
];

export const initGroupData = [
  { id: "col_1", title: "New(Changed)" },
  { id: "col_2", title: "Assigned" },
  { id: "col_3", title: "In Progress" },
  { id: "col_4", title: "On Hold" },
  { id: "col_5", title: "Closed" },
  { id: "col_6", title: "request" },
];
